import { stage_url, sub_urls } from "../api-urls";
import axios from "axios";
import Headers from "./Headers";

export const SchemesApi = {
  GetByFilters: async (payload) => {
    const response = await axios.get(stage_url + sub_urls.schemes.filter, {
      params: {
        page: payload.page,
        size: payload.size,
        brandId: payload.brandId,
        periodFrom: payload.periodFrom,
        periodTo: payload.periodTo,
      },
      headers: Headers.getHeaders(),
    });
    return response;
  },
  SearchByKeyword: async (payload) => {
    const response = await axios.get(stage_url + sub_urls.schemes.search, {
      params: {
        page: payload.page,
        size: payload.size,
        brandId: payload.brandId,
        periodFrom: payload.periodFrom,
        periodTo: payload.periodTo,
        keyword: payload.keyword,
        userGroups: payload.userGroups,
      },
      headers: Headers.getHeaders(),
    });
    return response;
  },
  AddScheme: async (payload) => {
    const response = await axios.post(
      stage_url + sub_urls.schemes.baseUrl,
      payload,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },
  UpdateScheme: async (payload) => {
    const response = await axios.put(
      stage_url + sub_urls.schemes.baseUrl + "/" + payload.id,
      payload,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },
  SearchByGroup: async (payload) => {
    const response = await axios.get(stage_url + sub_urls.group.search, {
      params: {
        page: payload.page,
        size: payload.size,
        keyword: payload.keyword,
      },
      headers: Headers.getHeaders(),
    });
    return response;
  },
  GetByV2Filter: async (payload) => {
    const response = await axios.get(
      stage_url + sub_urls.schemes.filterV2,
      {
        params: {
          brandId: payload.brandId,
          productId: payload.productId,
          keyword: payload.keyword,
          periodFrom: payload.periodFrom,
          periodTo: payload.periodTo,
          isActive: payload.isActive,
          page: payload.page,
          size: payload.size,
        },
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },
  AddSchemeV2: async (payload) => {
    const response = await axios.post(
      stage_url + sub_urls.schemes.addSchemeV2,
      payload,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  }
  ,
  UpdateSchemeV2: async (payload) => {
    const response = await axios.put(
      stage_url + sub_urls.schemes.addSchemeV2 + "/" + payload.id,
      payload,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },

  ExtractSchemesImageV2: async (payload) => {
    const response = await axios.post(
      stage_url + sub_urls.schemes.extractSchemesImageV2,
      payload,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },

  GetSchemeExtractDrafts: async () => {
    const response = await axios.get(
      stage_url + sub_urls.schemes.extractSchemesDrafts,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },

  BulkUploadSchemesV2: async (folder, formData) => {
    const response = await axios.post(
      stage_url + sub_urls.schemes.bulkUploadSchemesV2,
      formData,
      {
        params: { folder },
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },

  GetSchemeFolders: async () => {
    const response = await axios.get(
      stage_url + sub_urls.schemes.schemeFolders,
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },

  ExtractSchemeFolder: async (folder) => {
    const response = await axios.post(
      stage_url + sub_urls.schemes.extractSchemeFolderV2,
      null,
      {
        params: { folder },
        headers: Headers.getHeaders(),
        timeout: 300000,
      }
    );
    return response;
  },
};
